(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-shipping-bar"] && !Shopify.designMode) return;
  try {
    class CartShipBar extends HTMLElement {
    /** @type {Record<string, string>} */
    #messages = {};

    connectedCallback() {
      this.#messages = this.#readMessages();
      this.#update(Number(this.dataset.cartTotal) || 0);
    }

    #readMessages() {
      const node = this.querySelector('[data-ref="messages"]');
      if (!(node instanceof HTMLScriptElement)) return {};

      try {
        const parsed = JSON.parse(node.textContent || '{}');
        return parsed && typeof parsed === 'object' ? parsed : {};
      } catch {
        return {};
      }
    }

    /**
     * Money metafields are already presentment subunits.
     * Integers are shop-currency subunits; Shopify.currency.rate is shop → cart.
     * @returns {number}
     */
    #resolveThresholdCents() {
      if (this.dataset.isMoney === 'true' || this.dataset.sameCurrency === 'true') {
        return Number(this.dataset.threshold) || 0;
      }

      const shopCents = Number(this.dataset.shopCents) || 0;
      const rate = Number(window.Shopify?.currency?.rate);
      if (!(shopCents > 0 && Number.isFinite(rate) && rate > 0)) return 0;

      return Math.round(shopCents * rate);
    }

    /**
     * @param {number} cartTotal
     */
    #update(cartTotal) {
      const threshold = this.#resolveThresholdCents();
      if (!threshold) return;

      const remaining = Math.max(threshold - cartTotal, 0);
      const progress = Math.min((cartTotal / threshold) * 100, 100);
      const isEligible = cartTotal >= threshold;

      this.dataset.threshold = String(threshold);
      this.style.setProperty('--progress', `${progress}%`);
      this.classList.toggle('cart-ship-bar--eligible', isEligible);

      const message = this.querySelector('[ref="message"]');
      const successMessage = this.querySelector('[ref="successMessage"]');
      const success = this.querySelector('[ref="success"]');
      const progressbar = this.querySelector('[ref="progressbar"]');
      const awayTemplate = this.#messages.away || '';
      const eligibleMessage = this.#messages.eligible || '';

      if (message instanceof HTMLElement) {
        message.textContent = isEligible
          ? eligibleMessage
          : awayTemplate.replace('__amount__', this.#formatMoney(remaining));
      }

      if (successMessage instanceof HTMLElement) {
        successMessage.textContent = eligibleMessage;
      }

      if (success instanceof HTMLElement) {
        success.setAttribute('aria-hidden', isEligible ? 'false' : 'true');
      }

      if (progressbar instanceof HTMLElement) {
        progressbar.setAttribute('aria-valuenow', String(cartTotal));
        progressbar.setAttribute('aria-valuemax', String(threshold));
      }
    }

    /**
     * @param {number} cents
     * @returns {string}
     */
    #formatMoney(cents) {
      const currency = (this.dataset.currency || 'USD').toUpperCase();
      const locale = this.dataset.locale || document.documentElement.lang || 'en';

      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
        }).format(cents / 100);
      } catch {
        return `${(cents / 100).toFixed(2)} ${currency}`;
      }
    }
  }

  if (!customElements.get('cart-ship-bar')) {
    customElements.define('cart-ship-bar', CartShipBar);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["footer-localization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('footer-localization-form')) {
    customElements.define(
      'footer-localization-form',
      class FooterLocalizationForm extends HTMLElement {
        connectedCallback() {
          this.addEventListener('change', this.#submitForm);
        }

        disconnectedCallback() {
          this.removeEventListener('change', this.#submitForm);
        }

        #submitForm = (event) => {
          if (event.target instanceof HTMLSelectElement) {
            event.target.form?.submit();
          }
        };
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
